<div class="headline-container">
  <div mat-dialog-title>
    <su-headline h="h3" skin="primary">{{ data.title }}</su-headline>
  </div>
</div>

<div mat-dialog-content>
  <formly-form [form]="form" [fields]="formFields" [model]="formModel">
  </formly-form>

  <div *ngIf="form.get('documents')?.touched && form.get('documents')?.invalid">
    <div *ngIf="form.get('documents')?.errors?.noPrimary" class="error-message">
      {{ 'website_edit.dialog.error__noPrimaryImage' | translate }}
    </div>
    <div
      *ngIf="form.get('documents')?.errors?.multiplePrimary"
      class="error-message">
      {{ 'website_edit.dialog.error__multiplePrimaryImages' | translate }}
    </div>
    <div
      *ngIf="form.get('documents')?.errors?.missingFile"
      class="error-message">
      {{ 'website_edit.dialog.error__missingImage' | translate }}
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <su-button
    *ngIf="rentalListingId"
    skin="secondary"
    [label]="'website_edit.dialog.label__delete' | translate"
    (onClick)="deleteRentalListing()"></su-button>

  <su-button
    skin="secondary"
    [label]="'shared.cancel' | translate"
    mat-dialog-close>
  </su-button>

  <su-button
    skin="primary"
    [label]="'shared.save' | translate"
    (onClick)="submitForm()"></su-button>
</div>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
